import {Component} from '@angular/core';
import { PropertyService } from '../services/property.service';
import { Property } from '../../../../types/admin-data.types';


@Component({
    selector: 'property-group-list',
    templateUrl: './property-group-list.component.html',
    styleUrls: ['./property-group-list.component.scss']
})
export class PropertyGroupListComponent {

    constructor(public propertyService: PropertyService) {}

    removeItem(item) {
        this.propertyService.remove(item.id);
    }

    editBuildings(item) {
        this.propertyService.selectedBuildings = [];
        this.propertyService.currentCorporationNumber = item;
        if(this.propertyService.currentCorporationNumber.buildings) {
            this.propertyService.currentCorporationNumber.buildings.forEach((res) => {
                const buildings = this.propertyService.buildingsList.filter(item => item.id == res);
                if(buildings.length > 0)
                    this.propertyService.selectedBuildings.push(buildings[0]);
            });
        }

        this.propertyService.isCreateNew = true;
    }

    toggleDetails(item): void {
        this.propertyService.isShowView = this.propertyService.toggleCheck(item);

        if (this.propertyService.isShowView) {
            this.propertyService.viewedItem = item;
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/property-group-list/property-group-list.component.ts